import type { ObjectValues } from '../interfaces/object-valuest';

export const SIGNATURE_STATUS = {
  WaitingSigningFields: 'Waiting for signing fields',
  CollectingSignatures: 'Collecting signatures',
  SigningComplete: 'Signing complete',
} as const;

export type SignatureStatus = ObjectValues<typeof SIGNATURE_STATUS>;
